// Colombia Legal & Economic Constants for Calculators

export interface YearEconomicData {
  year: number;
  smlmv: number;
  auxilioTransporte: number;
  ipcAnual: number; // percentage
}

export const COLOMBIA_ECONOMIC_DATA: Record<number, YearEconomicData> = {
  2018: { year: 2018, smlmv: 781242, auxilioTransporte: 88211, ipcAnual: 3.18 },
  2019: { year: 2019, smlmv: 828116, auxilioTransporte: 97032, ipcAnual: 3.80 },
  2020: { year: 2020, smlmv: 877803, auxilioTransporte: 102854, ipcAnual: 1.61 },
  2021: { year: 2021, smlmv: 908526, auxilioTransporte: 106454, ipcAnual: 5.62 },
  2022: { year: 2022, smlmv: 1000000, auxilioTransporte: 117172, ipcAnual: 13.12 },
  2023: { year: 2023, smlmv: 1160000, auxilioTransporte: 140606, ipcAnual: 9.28 },
  2024: { year: 2024, smlmv: 1300000, auxilioTransporte: 162000, ipcAnual: 5.20 },
  2025: { year: 2025, smlmv: 1423500, auxilioTransporte: 175000, ipcAnual: 4.50 },
  2026: { year: 2026, smlmv: 1550000, auxilioTransporte: 190000, ipcAnual: 4.00 },
};

export const SMLMV_2026 = 1550000;
export const AUX_TRANSPORTE_2026 = 190000;
export const SMLMV_2025 = 1423500;
export const AUX_TRANSPORTE_2025 = 175000;

// Quantia limits in SMLMV (CGP Art. 25)
export const MINIMA_CUANTIA_SMLMV = 40; // hasta 40 SMLMV
export const MENOR_CUANTIA_SMLMV = 150; // de 40 a 150 SMLMV
// Mayor cuantía > 150 SMLMV

// IPC Cumulative Index table baseline (Reference index starting 2010=100)
export const IPC_MONTHLY_INDEX: Record<string, number> = {
  "2020-01": 104.5, "2020-06": 105.2, "2020-12": 105.8,
  "2021-01": 106.1, "2021-06": 108.3, "2021-12": 111.8,
  "2022-01": 113.7, "2022-06": 121.1, "2022-12": 126.5,
  "2023-01": 128.8, "2023-06": 135.2, "2023-12": 138.2,
  "2024-01": 139.5, "2024-06": 143.8, "2024-12": 145.4,
  "2025-01": 146.8, "2025-06": 149.5, "2025-12": 151.9,
  "2026-01": 153.2, "2026-06": 155.8, "2026-08": 156.4,
};

// Default monthly technical interest rate for actuarial calculations in Colombia (0.5% monthly = 6% annual)
export const TASA_TECNICA_MENSUAL = 0.005;
export const TASA_TECNICA_ANUAL = 0.06;

// Life Expectancy Table (Superintendencia Financiera de Colombia - Rentistas/Población General)
// Remaining years of life based on current age
export function getExpectativaVidaRestante(edad: number, sexo: "masculino" | "femenino"): number {
  const base = sexo === "femenino" ? 82 : 77;
  const rem = Math.max(1, base - edad);
  return rem;
}

// Colombian National Holidays 2025-2026
export const FESTIVOS_COLOMBIA = [
  "2025-01-01", "2025-01-06", "2025-03-24", "2025-04-17", "2025-04-18",
  "2025-05-01", "2025-06-02", "2025-06-23", "2025-06-30", "2025-07-20",
  "2025-08-07", "2025-08-18", "2025-10-13", "2025-11-03", "2025-11-17",
  "2025-12-08", "2025-12-25",
  "2026-01-01", "2026-01-12", "2026-03-23", "2026-04-02", "2026-04-03",
  "2026-05-01", "2026-05-18", "2026-06-08", "2026-06-15", "2026-06-29",
  "2026-07-20", "2026-08-07", "2026-08-17", "2026-10-12", "2026-11-02",
  "2026-11-16", "2026-12-08", "2026-12-25"
];
